import { observer } from 'mobx-react';
import { LicenseFamily } from '../../../../Organization/Types';
import ParticipantStore from '../../../../ParticipantStore';
import LicenseStatus from './LicenseStatus';
import UserLicenses from './UserLicenses';

interface Props {
  store: ParticipantStore;
  licenseFamily: LicenseFamily;
}

function LimaColumns({ store, licenseFamily }: Props) {
  switch (licenseFamily) {
    case 'lima':
      return (
        <>
          <td className="hidden whitespace-nowrap px-3 py-4 text-sm text-gray-500 lg:table-cell">
            <UserLicenses store={store} />
          </td>
          <td className="hidden whitespace-nowrap px-3 py-4 text-sm text-gray-500 lg:table-cell">
            <LicenseStatus store={store} />
          </td>
        </>
      );
    case 'classic':
      return <></>;
  }
}

export default observer(LimaColumns);
